/**
 * 照片王(AI 问照片 / AIPhotoKing 页面)共享常量。
 */

/**
 * 照片王页面内所有下单的统一来源标记。
 *
 * 链路:openVipByKind / setPaymentVisible 的 sourceDetail → POST /web/order/create
 * body.sourceDetail → ordercenter 落库 order_record.source_detail → 服务端埋点
 * ServerOrderDataSyncSuc4 原样上报;同时也是前端 web_click_page_workgroup_open_vip
 * 埋点的 source_detail(2026-06-11 埋点平台已登记该枚举,细分来源挪 string2)。
 *
 * 例外:「单次付费批量下载」仍传 'downloadOnce' —— 该值是功能路由开关
 * (useIsPaymentV2DownloadOnceRoute / PaymentV2 pageType='payOnce'),改值会让
 * 单次付费支付页无法唤起,不属于纯来源标记,不参与归一。
 */
export const AI_PHOTO_KING_SOURCE_DETAIL = 'the_king_of_AI_photo'
